/**
 * Creamy Loots — Manifest Page JS
 * Scroll reveal · animated counters · parallax · chapter number scramble
 */
(function () {
  'use strict';

  /* ── SCROLL REVEAL ──────────────────────────────────────────────────────── */

  function initReveal() {
    const els = document.querySelectorAll('[data-mp-reveal]');
    if (!els.length) return;

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    els.forEach(el => obs.observe(el));
  }

  /* ── ANIMATED COUNTERS ──────────────────────────────────────────────────── */

  function animateCount(el) {
    const target   = parseInt(el.dataset.mpCount, 10);
    const duration = 1800;
    const steps    = Math.ceil(duration / (1000 / 60));
    let   cur      = 0;

    const tick = () => {
      cur = Math.min(cur + target / steps, target);
      el.textContent = Math.floor(cur).toLocaleString('es-CO');
      if (cur < target) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  function initCounters() {
    const counters = document.querySelectorAll('[data-mp-count]');
    if (!counters.length) return;

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            animateCount(e.target);
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.6 }
    );

    counters.forEach(c => obs.observe(c));
  }

  /* ── PARALLAX ───────────────────────────────────────────────────────────── */

  function initParallax() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const items = document.querySelectorAll('[data-mp-parallax]');
    if (!items.length) return;

    const update = () => {
      items.forEach(img => {
        const wrap = img.closest('[data-mp-parallax-wrap]');
        if (!wrap) return;
        const rect  = wrap.getBoundingClientRect();
        const rel   = (window.innerHeight * 0.5 - rect.top - rect.height * 0.5) / window.innerHeight;
        const speed = parseFloat(img.dataset.mpParallax) || 0.14;
        img.style.transform = `translateY(${(rel * speed * 100).toFixed(2)}px) scale(1.12)`;
      });
    };

    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ── NUMBER SCRAMBLE ────────────────────────────────────────────────────── */

  const DIGITS = '0123456789';

  function scramble(el) {
    const final = el.dataset.mpScramble;
    let   pos   = 0;

    const iter = setInterval(() => {
      el.textContent = final.split('').map((ch, i) => {
        if (i < pos) return final[i];
        return DIGITS[Math.floor(Math.random() * DIGITS.length)];
      }).join('');

      pos += 0.6;
      if (pos >= final.length + 1) {
        el.textContent = final;
        clearInterval(iter);
      }
    }, 45);
  }

  function initScramble() {
    const els = document.querySelectorAll('[data-mp-scramble]');
    if (!els.length) return;

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            scramble(e.target);
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.4 }
    );

    els.forEach(el => {
      el.textContent = el.dataset.mpScramble.replace(/\d/g, '?');
      obs.observe(el);
    });
  }

  /* ── INIT ───────────────────────────────────────────────────────────────── */

  function init() {
    initReveal();
    initCounters();
    initParallax();
    initScramble();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();